"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const aurora_js_formatters_1 = require("@ecg-internal/aurora-js-formatters");
/**
 *
 * Often we need to send SEO friendly category name to our third party partners
 * because this is now using the dataLayer category name, it is not consistent across multiple BFF's
 * This method aims to fix that issue, it will always format the category name if available
 * and add it to the existing datalayer variable, so it can be used

 */
const getSeoFriendlyCategoryName = (l1) => {
    let l1Ascii = l1.n || '';
    try {
        l1Ascii = (0, aurora_js_formatters_1.seoUrlPart)(l1.n || '');
    }
    catch {
        // do nothing
    }
    return {
        id: l1.id,
        n: l1Ascii,
    };
};
exports.default = getSeoFriendlyCategoryName;
//# sourceMappingURL=getSeoFriendlyCategoryName.js.map